import { Loader } from 'component/customComponents/loader/loader';
import React, { ComponentProps, ReactElement, Suspense, lazy } from 'react';

const LazyStudentMain = lazy(() =>
  import('./StudentMain')
    .then((module) => ({ default: module.StudentMain }))
    .catch(() => {
      document.location.reload();
      return { default: (): JSX.Element => <></> };
    })
);

export const StudentMain = (
  props: ComponentProps<typeof LazyStudentMain>
): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyStudentMain {...props} />
  </Suspense>
);
